<template>
  <AuthContainer>
    <div class="text-left my-8">
      <h1 class="text-3xl md:text-4xl font-semibold mb-4 capitalize">
        {{ $t('auth.becomeMember.title') }}
      </h1>
    </div>

    <form @submit.prevent="onSubmit" class="space-y-6 text-sm">
      <BaseInput
        id="userPrenom"
        :label="$t('auth.becomeMember.form.firstName')"
        type="text"
        v-model="form.userPrenom.value.value"
        width="w-full"
        :onChange="form.userPrenom.handleChange"
        :disabled="isLoading"
        :error="form.userPrenom.errorMessage.value"
      />

      <BaseInput
        id="userNom"
        :label="$t('auth.becomeMember.form.lastName')"
        type="text"
        v-model="form.userNom.value.value"
        width="w-full"
        :onChange="form.userNom.handleChange"
        :disabled="isLoading"
        :error="form.userNom.errorMessage.value"
      />

      <BaseInput
        id="userEmail"
        :label="$t('auth.becomeMember.form.email')"
        type="text"
        v-model="form.userEmail.value.value"
        width="w-full"
        :onChange="form.userEmail.handleChange"
        :error="form.userEmail.errorMessage.value"
        :disabled="isLoading"
      />

      <BaseInput
        id="password"
        :label="$t('auth.resetPassword.form.password')"
        type="password"
        v-model="form.userLogin.value.value"
        width="w-full"
        :disabled="isLoading"
        :error="errors.userLogin"
        :onChange="form.userLogin.handleChange"
        :placeholder="$t('auth.signIn.form.passwordPlaceholder')"
      />

      <BaseInput
        id="ConfirmPassword"
        :label="$t('auth.resetPassword.form.confirmPassword')"
        type="password"
        v-model="form.confirmUserLogin.value.value"
        width="w-full"
        :placeholder="$t('auth.signIn.form.passwordPlaceholder')"
        :disabled="isLoading"
        :error="errors.confirmUserLogin"
        :onChange="form.confirmUserLogin.handleChange"
      />

      <div
        v-if="userStore.errorWhileSignUp.length > 0"
        class="p-3 bg-red-50 border border-red-200 rounded-md"
      >
        <p class="text-sm text-red-600 text-center">
          <template v-if="userStore.errorWhileSignUp === ErrorKey.EMAILTAKEN">{{
            $t('auth.becomeMember.emailError')
          }}</template>
          <template v-else>{{ $t('auth.becomeMember.globalError') }}</template>
        </p>
      </div>
      <BaseButton type="submit" :loading="isLoading" :disabled="!meta.valid" width="w-full">
        {{ $t('auth.becomeMember.title') }}
      </BaseButton>
    </form>

    <p class="mt-8 md:mt-12 2xl:mt-14 text-center text-sm">
      {{ $t('auth.signIn.alreadyAccount') }}
      <router-link
        append
        class="hover:text-main-hover cursor-pointer font-medium transition-colors"
        :to="{ name: RoutesKey.AUTH_SIGN_IN }"
      >
        {{ $t('auth.signIn.form.submit') }}
      </router-link>
    </p>
  </AuthContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { UserProfileForm } from '@/services/userAndAuth/forms/UserProfileForm'
import BaseInput from '@/components/ui/BaseInput.vue'
import { debounce } from '@/services/utils/UtilsService'
import BaseButton from '@/components/ui/BaseButton.vue'
import { useUserStore } from '@/stores/userStore'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import AuthContainer from './AuthContainer.vue'
import { useRouter } from 'vue-router'
import { ErrorKey } from '@/models/enums/app/ErrorKey'

const { form, handleSubmit, meta, errors } = UserProfileForm.getSignUpForm()
const userStore = useUserStore()
const isLoading = ref(false)
const router = useRouter()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const debouncedSignUp = debounce(async (values: any) => {
  isLoading.value = true
  await userStore.signUp(values)
  if (userStore.errorWhileSignUp.length === 0) {
    router.push({
      name: RoutesKey.AUTH_EMAIL_VERIFIER_ASK,
      query: { email: values.userEmail },
    })
  }

  isLoading.value = false
}, 500)

const onSubmit = handleSubmit(
  (values) => {
    debouncedSignUp(values)
  },
  (errors) => {
    console.error('Form validation failed:', errors.values)
  },
)
</script>
